import { useEffect } from 'react';

import { ListApiConfig, ListControls } from '../types/list';
import { buildListParams } from '../util/listApiParams';

interface UseListFetcherArgs {
  hasHydrated: boolean;
  controlsFromStore: ListControls;
  config: ListApiConfig;
  fetchThunk: (params: Record<string, any>) => void | Promise<void>;
}

export function useListFetcher({
  hasHydrated,
  controlsFromStore,
  config,
  fetchThunk,
}: UseListFetcherArgs): void {
  useEffect(() => {
    if (!hasHydrated) return;
    const { page, pageSize, search, sort } = controlsFromStore;
    const params = buildListParams({ page, pageSize, search, sort }, config);
    void fetchThunk(params);
  }, [
    hasHydrated,
    controlsFromStore.page,
    controlsFromStore.pageSize,
    controlsFromStore.search,
    controlsFromStore.sort,
    config,
    fetchThunk,
  ]);
}
